import { MappableModel } from './mappable-model'

export class PhoneNumber extends MappableModel {
  public id: number
  public number: string
  public phone_type: string
}
